/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { useLayout } from '../../core';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import { AsideTabs } from './AsideTabs';
import { AsideFooter } from './AsideFooter';
import { TabsBase } from './Tabs/_TabsBase';
import AddEmployeeSubMenu from '../../../../app/pages/Employees/componenets/AddEmployee/add-employee-menu/components/AddEmployeeSubMenu';
import { PathContext } from '../../../../app/pages/Employees/componenets/AddEmployee/user-context/path-context/PathContext';
import EditEmployeeMenu from '../../../../app/pages/Employees/componenets/edit-employee-menu/components/EditEmployeeMenu';
import { getSettingValue } from '../../../../app/helper-functions/general_settings_helper';
const AsideDefault = () => {
  const { config } = useLayout();
  const {pathname} = useLocation();
  const { classes } = useLayout();
  const [logo, setLogo] = useState("");
  const { isPathMatched} = useContext(PathContext);
  const [isClicked, setIsClicked] = useState(false);
  const [link, setLink] = useState(() => {
    // Retrieve the previous link value from local storage, but only if it's not on initial page load (prevent on refresh)
    return localStorage.getItem('previousLink') || ''; // Use localStorage instead to avoid persisting on refresh
});
  const navigate=useNavigate();
  const hasNavigated = useRef(false);  // Add useRef to track navigation
  useEffect(() => {
    if (link === "user-managements" && !hasNavigated.current) {
      hasNavigated.current = true;  // Ensure navigation happens only once for this change
      localStorage.removeItem("pathMatched");
      localStorage.removeItem("pathMatchedEditEmployeeMenu") // Remove the item from localStorage
      navigate(pathname); // Navigate to the desired path
    }else if (link === "settings" && !hasNavigated.current){
      hasNavigated.current = true;  // Ensure navigation happens only once for this change
      localStorage.removeItem("pathMatched");
      localStorage.removeItem("pathMatchedEditEmployeeMenu") // Remove the item from localStorage
    navigate(pathname)
    }else if(link === "organization" && !hasNavigated.current){
      hasNavigated.current = true;  // Ensure navigation happens only once for this change
      localStorage.removeItem("pathMatched");
      localStorage.removeItem("pathMatchedEditEmployeeMenu") // Remove the item from localStorage
     navigate(pathname)
    }else if(link === "reports" && !hasNavigated.current){
      hasNavigated.current = true;  // Ensure navigation happens only once for this change
      localStorage.removeItem("pathMatched");
      localStorage.removeItem("pathMatchedEditEmployeeMenu") // Remove the item from localStorage
     navigate(pathname)
    }
  }, [link, navigate]);
  useEffect(() => {
    setLogo(getSettingValue('white_logo'));
  }, [])
  
  // Reset `hasNavigated` when the link changes
  useEffect(() => {
    hasNavigated.current = false;
  }, [link]);
    // Retrieve the value from localStorage to determine if the menu should be shown
    const shouldShowAddEmployeeMenu = localStorage.getItem("pathMatched") === "showAddEmployeeMenu";
    const shouldEditEmployeeMenu = localStorage.getItem("pathMatchedEditEmployeeMenu") === "showEditEmployeeMenu"  
    useEffect(() => {
    // Store the current link value in local storage
    localStorage.setItem('previousLink', link);
  }, [link]);
const handleClick = () => {
  // Toggle the state
  setIsClicked((prevState) => !prevState);

  if (isClicked) {
    // If the menu is open, disable the secondary aside
    document.body.classList.remove('aside-secondary-enabled');
    document.body.classList.add('aside-secondary-disabled');
  } else {
    // If the menu is closed, enable the secondary aside
    document.body.classList.remove('aside-secondary-disabled');
    document.body.classList.add('aside-secondary-enabled');
  }
};
  return (
    <div
      id='kt_aside'
      className={clsx('aside aside-extended', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width='auto'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      {/* begin::Primary */}
      <div className='aside-primary bg-dark d-flex flex-column align-items-lg-center flex-row-auto'>
        {/* begin::Logo */}
        <div
          className='aside-logo d-none d-lg-flex flex-column align-items-center flex-column-auto py-10'
          id='kt_aside_logo'
        >
          <Link to='/dashboard'>
          {
                      (!localStorage.getItem("favicon") || localStorage.getItem("favicon") === 'null') ? (
                        <h1 className='text-white fs-1 fw-bolder text-center'>
                      Wriko People
                      </h1>
                      ) : (
                        <Link to='/' className='mb-5'>
                          <img
                          alt='Wriko People'
                          src={localStorage.getItem("favicon") || undefined}
                          className='h-55px app-sidebar-logo-left app-sidebar-logo-default theme-light-show'
                          />
                        </Link>
                      )
                    }
          </Link>
        </div>
        {/* end::Logo */}
        {/* begin::Nav */}
        <div
          className='aside-nav d-flex flex-column align-items-center flex-column-fluid w-100 pt-5 pt-lg-0'
          id='kt_aside_nav'
        >
          <AsideTabs link={link} setLink={setLink} />
        </div>
        {/* end::Nav */}
        <AsideFooter />
      </div>
      {/* end::Primary */}
      {config.aside.secondaryDisplay && (
        <>
          {/* begin::Secondary */}
          <div className='aside-secondary bg-dark d-flex flex-row-fluid'>
            {/* begin::Workspace */}
            <div className='aside-workspace my-5 p-5' id='kt_aside_wordspace'>
              {
                shouldShowAddEmployeeMenu ? (
                  <AddEmployeeSubMenu />
                ) : shouldEditEmployeeMenu ? (
                  <EditEmployeeMenu /> 
                ) : (
                  <TabsBase link={link} />
                )
              }
            </div>
            { }
          </div>
          {/* end::Secondary */}
        </>
      )}
      
          {/* begin::Aside Toggle */}
          <button
        id="kt_aside_toggle"
        className={clsx(
          'btn btn-sm btn-icon bg-body btn-color-gray-700 btn-active-primary position-absolute translate-middle start-100 end-0 bottom-0 shadow-sm',
          isClicked ? 'active' : '',
          classes.asideToggle.join(' ')
        )}
        onClick={handleClick}
        style={{ marginBottom: '1.35rem' }}
      >
        <KTIcon
          iconName="arrow-right"
          className={clsx('fs-2', isClicked ? 'rotate-180' : '')} // Rotate the arrow
        />
      </button>
      {/* end::Aside Toggle */}
    </div>
  );
};

export { AsideDefault };
